import React, { ReactNode, FC } from 'react';
import { Box } from '@mui/material';

import { BigidMeIconView } from '../../../../../../assets/icons/BigidMeIconView';
import { NormalizedFormFieldOption, RequestorTypeType, RequestVariantType } from '../../../../../types/common';
import { BigidMeIconUpdate } from '../../../../../../assets/icons/BigidMeIconUpdate';
import { BigidMeIconDelete } from '../../../../../../assets/icons/BigidMeIconDelete';
import { BigidMeIconPreferences } from '../../../../../../assets/icons/BigidMeIconPreferences';
import { BigidMeIconOptOut } from '../../../../../../assets/icons/BigidMeIconOptOut';
import { BigidMeIconAppeal } from '../../../../../../assets/icons/BigidMeIconAppeal';
import { BigidMeIconRequestorTypeSelf } from '../../../../../../assets/icons/BigidMeIconRequestorTypeSelf';
import { BigidMeIconRequestorTypeAuthorizedAgent } from '../../../../../../assets/icons/BigidMeIconRequestorTypeAgent';
import { DescriptionAccordion } from './DescriptionAccordion';
import {
  StyledContentBox,
  StyledContentCard,
  StyledDescription,
  StyledRadioButton,
  StyledTitle,
} from './RequestTypeFieldStyles';
import { e2e } from '../../../../../../utils';

const thumbnailIconsMap = new Map<string, ReactNode>([
  [RequestVariantType.VIEW, <BigidMeIconView key={'view'} />],
  [RequestVariantType.UPDATE, <BigidMeIconUpdate key={'update'} />],
  [RequestVariantType.DELETE, <BigidMeIconDelete key={'delete'} />],
  [RequestVariantType.PREFERENCES, <BigidMeIconPreferences key={'preferences'} />],
  [RequestVariantType.OPT_OUT, <BigidMeIconOptOut key={'optOut'} />],
  [RequestVariantType.APPEAL, <BigidMeIconAppeal key={'appeal'} />],
  [RequestorTypeType.SELF, <BigidMeIconRequestorTypeSelf key={'self'} />],
  [RequestorTypeType.AUTHORIZED_AGENT, <BigidMeIconRequestorTypeAuthorizedAgent key={'authorizedAgent'} />],
  ['Default', <BigidMeIconView key={'default'} />],
]);

type RequestTypeFieldPropsType = {
  options: NormalizedFormFieldOption[];
  value?: string;
  isDisabled?: boolean;
  onSelect: (value: string) => void;
};

export const RequestTypeField: FC<RequestTypeFieldPropsType> = ({ options, value, isDisabled, onSelect }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 1,
      }}
    >
      {options.map(option => (
        <StyledContentCard
          tabIndex={0}
          key={option.id}
          selected={value === option.value}
          onClick={e => {
            onSelect(option.value);
            e?.currentTarget.blur();
          }}
          {...e2e(`thumbnail_${option.id}`)}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'right',
            }}
            onClick={e => e.stopPropagation()}
          >
            <StyledRadioButton
              aria-label={option.displayValue}
              label=""
              value={value === option.value}
              checked={value === option.value}
              onChange={e => {
                e.stopPropagation();
                onSelect(option.value);
              }}
              disabled={isDisabled}
            />
          </Box>
          <StyledContentBox className="item-primary-info">
            <Box
              sx={{
                svg: {
                  width: {
                    xs: '29px',
                    sm: '58px',
                  },
                  height: {
                    xs: '29px',
                    sm: '58px',
                  },
                },
              }}
            >
              {thumbnailIconsMap.get(option.value) || thumbnailIconsMap.get('default')}
            </Box>
            <StyledTitle size="large">{option.displayValue}</StyledTitle>
          </StyledContentBox>
          <StyledDescription className="item-description">{option.description}</StyledDescription>
          <Box sx={{ display: { sm: 'none' } }}>
            <DescriptionAccordion text={option.description} />
          </Box>
        </StyledContentCard>
      ))}
    </Box>
  );
};
